import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./KlyzenProduction.css";

function KlyzenProductions() {
  const services = [
    {
      title: "Advertisement Campaigns",
      description:
        "Creative campaigns across digital, TV, and social media to boost brand visibility and engagement.",
      icon: "📢",
    },
    {
      title: "OTT & Film Production",
      description:
        "End-to-end production for films, web series, and OTT content — scripting, shooting, editing, and distribution.",
      icon: "🎬",
    },
    {
      title: "Animation & Cartoon Production",
      description:
        "High-quality 2D/3D animation, motion graphics, cartoon series, and visual storytelling.",
      icon: "🎨",
    },
    {
      title: "Podcast Production",
      description:
        "Professional audio recording, editing, and publishing for podcasts and branded audio content.",
      icon: "🎙️",
    },
    {
      title: "Event Coverage & Production",
      description:
        "Capture and produce live events, conferences, and corporate campaigns with cinematic quality.",
      icon: "📸",
    },
    {
      title: "Web Series & Movie Production",
      description:
        "Complete production management from pre-production, shooting, post-production to final release.",
      icon: "🎥",
    },
    {
      title: "Brand Video Production",
      description:
        "Engaging brand videos to tell your story and enhance your marketing campaigns.",
      icon: "🎞️",
    },
    {
      title: "Social Media Content Production",
      description:
        "Custom content for social media platforms including reels, shorts, and promotional clips.",
      icon: "📱",
    },
  ];

  const highlights = [
    "End-to-end Production Services",
    "Experienced Creative Team",
    "State-of-the-Art Equipment",
    "Fast Turnaround & Premium Quality",
    "Custom Storytelling for Brands & Entertainment",
    "Dedicated Project Managers",
  ];

  return (
    <>
      <Navbar />

      {/* HERO */}
      <section className="prod-hero">
        <div className="prod-overlay" />
        <div className="prod-hero-content">
          <h1>Klyzen Productions</h1>
          <h2>Creative Media & Film Production</h2>
          <p>Bringing Ideas to Life with Premium Production Services</p>
        </div>
      </section>

      {/* ABOUT */}
      <section className="prod-section">
        <h2>About Klyzen Productions</h2>
        <p className="prod-text">
          Klyzen Productions, a division of Klyzen Ventures LLP, provides world-class production services across film, animation, advertising, OTT, events, and podcasts. Our creative team ensures every project is executed with precision, innovation, and cinematic excellence.
        </p>
      </section>

      {/* HIGHLIGHTS */}
      <section className="prod-section prod-alt">
        <h2>Why Choose Klyzen Productions</h2>
        <div className="highlights-grid">
          {highlights.map((item, idx) => (
            <div key={idx} className="highlight-card">
              <span className="highlight-icon">⭐</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section className="prod-section">
        <h2>Our Services</h2>
        <div className="services-grid">
          {services.map((service, idx) => (
            <div key={idx} className="service-card prod-hover">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="prod-cta">
        <h2>Bring Your Vision to Life</h2>
        <p>
          Let Klyzen Productions handle your creative media, film, and advertising projects with unmatched expertise.
        </p>
        <div className="cta-buttons">
          <a href="/contact" className="cta-btn prod-hover-btn">Contact Us</a>
          {/* <a href="/quote" className="cta-btn prod-hover-btn">Request a Quote</a> */}
        </div>
      </section>

      <Footer />
    </>
  );
}

export default KlyzenProductions;
